import React from 'react';
import { FaCheck } from 'react-icons/fa6';
import './QuestionCard.css';

const QuestionCard = ({ question, selectedValue, onSelect }) => {
  const { title, subtitle, options, multiSelect } = question;

  const isSelected = (value) => {
    if (multiSelect) {
      return Array.isArray(selectedValue) && selectedValue.includes(value);
    }
    return selectedValue === value;
  };

  const handleOptionClick = (value) => {
    if (multiSelect) {
      const current = Array.isArray(selectedValue) ? selectedValue : [];
      if (current.includes(value)) {
        onSelect(current.filter((v) => v !== value));
      } else {
        onSelect([...current, value]);
      }
    } else {
      onSelect(value);
    }
  };

  return (
    <div className="question-card">
      <div className="question-card-header">
        <h1 className="question-card-title">{title}</h1>
        {subtitle && <p className="question-card-subtitle">{subtitle}</p>}
      </div>

      <div className="question-card-options">
        {options.map((option) => {
          const selected = isSelected(option.value);
          return (
            <button
              key={option.value}
              type="button"
              className={`question-option ${selected ? 'selected' : ''}`}
              onClick={() => handleOptionClick(option.value)}
              aria-pressed={selected}
            >
              <div className="question-option-text">
                <span className="question-option-label">{option.label}</span>
                {option.sublabel && (
                  <span className="question-option-sublabel">{option.sublabel}</span>
                )}
              </div>
              <div className={`question-option-check ${selected ? 'visible' : ''}`}>
                <FaCheck className="question-option-check-icon" />
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default QuestionCard;
